module.exports = require('./$.global');